<template>
  <transition name="notification">
    <div :class="[$style.notificationContainer, $style[type]]" v-if="message">
      <div :class="$style.iconContainer">
        <div :class="$style.icon">
          <svg v-if="type === 'info'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
          </svg>
          <svg v-if="type === 'error'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
          </svg>
        </div>
      </div>
      <span :class="$style.message">{{ message }}</span>
      <button @click="$emit('close')" :class="$style.closeButton">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { useCssModule } from 'vue';

defineProps<{
  type: 'info' | 'error';
  message: string;
}>();

defineEmits(['close']);

const $style = useCssModule();
</script>

<style module scoped>
.notificationContainer {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-width: 90%;
  min-width: 280px;
  backdrop-filter: blur(8px);
}

.iconContainer {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.message {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
}

.info {
  background-color: rgba(253, 253, 253, 0.95);
  color: #0369a1;
}

.error {
  background-color: rgba(253, 253, 253, 0.95);
  color: #b91c1c;
}

.closeButton {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 8px;
  padding: 4px;
  opacity: 0.7;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.closeButton:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.05);
}

/* Transition styles */
.notification-enter-active {
  transition: opacity 0.4s ease, transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.notification-leave-active {
  transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.6, -0.28, 0.735, 0.045);
}

.notification-enter-from {
  opacity: 0;
  transform: translate(-50%, -15px);
}

.notification-leave-to {
  opacity: 0;
  transform: translate(-50%, -10px);
}

.notification-enter-to,
.notification-leave-from {
  opacity: 1;
  transform: translateX(-50%);
}
</style> 